import React, { memo } from 'react';

import MoneyRefund from '../../assets/money-refund.svg';

export default memo((props: { width?: string; height?: string; viewBox?: string }) => (
  <MoneyRefund
    alt="Money refund"
    data-testid="money-refund-icon"
    data-cy="money-refund-icon"
    {...props}
  />
));
